const MemberTier = {
  path: "",
  name: "",
  redirect: "/membertier",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/membertier",
      redirect: "/membertier",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Member Tier",
      meta: {
        requiresAuth: true,
        activeUrl: "/membertier",
        parent: "membertier",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/memberTier/index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/membertier",
            parent: "membertier",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Member Tier Detail",
          component: () => import("@/views/pages/memberTier/detail/Detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/membertier",
            parent: "membertier",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default MemberTier;
